import { useEffect, useState } from 'react';

export default function useSettingsIsMobile(context) {
  const viewportIsMobile = context.viewport.getIsMobile();
  const [mediaIsMobile, setMediaIsMobile] = useState(() => {
    if (typeof window === 'undefined') return viewportIsMobile;

    return window.matchMedia('(max-width: 900px)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const mediaQuery = window.matchMedia('(max-width: 900px)');
    const syncMedia = () => setMediaIsMobile(mediaQuery.matches);

    syncMedia();

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', syncMedia);
      return () => mediaQuery.removeEventListener('change', syncMedia);
    }

    mediaQuery.addListener(syncMedia);
    return () => mediaQuery.removeListener(syncMedia);
  }, []);

  return viewportIsMobile || mediaIsMobile;
}
